export const logoutRoute = '/logout';
